// Globals
import React, { HTMLAttributeReferrerPolicy } from 'react';

// UI
import { Modal } from 'antd';

// Locals
import styles from '../Components.module.css';

const GiidePlayerModal: React.FC<{
  showModal: boolean;
  setShowModal: ({ visible, giideId }) => void;
  giideId: string;
}> = ({ showModal, setShowModal, giideId }) => {
  const source = `https://${process.env.REACT_APP_EMBED_URL}/giide/v2/giide-${giideId}`;

  return (
    <Modal
      onCancel={() => setShowModal({ visible: false, giideId })}
      open={showModal}
      title={null}
      footer={null}
      centered
      destroyOnClose
    >
      <div className={styles.embeddedGiideWrapper}>
        <iframe
          title="Giide Web Player"
          src={source}
          referrerPolicy={'origin strict-origin' as HTMLAttributeReferrerPolicy}
          loading={'lazy'}
        />
      </div>
    </Modal>
  );
};

export default GiidePlayerModal;
